/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Tooltip } from "@mui/material";
import { useHistory } from "react-router-dom";
import "./Pieces.css";
import Locale from "../../../locales";
import { fetchPieces, selectStudent } from "../../../redux/actions";

export const cardBackground = {
  idle: "pieces-list-item darkgrey",
  ongoing: "pieces-list-item yellow",
  completed: "pieces-list-item green",
  inCompleted: "pieces-list-item red",
};

const Pieces = ({ summaryStudent }) => {
  const history = useHistory();
  const pieces = useSelector((state) => state.teacherReducer.pieces);
  const dispatch = useDispatch();

  const goToPiecesHandler = () => {
    dispatch(selectStudent(summaryStudent));
    dispatch(fetchPieces(summaryStudent));
    history.push("/pieces");
  };

  return (
    <Tooltip arrow title={Locale.t("click_to_manage_pieces")}>
      <div onClick={goToPiecesHandler} className="pieces-summary-container">
        <div className="heading">
          <p>{Locale.t("pieces")}</p>
        </div>
        <div className="pieces-list-container">
          {pieces.map((piece) => (
            <div
              className={cardBackground[piece.pieceStatus]}
              key={piece.pieceId}>
              <p>{piece.pieceTitle}</p>
            </div>
          ))}
          {pieces.length === 0 && (
            <div className={cardBackground.idle}>
              <p>{Locale.t("no_pieces_created")}</p>
            </div>
          )}
        </div>
      </div>
    </Tooltip>
  );
};

export default Pieces;
